// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2zmTS","card-content":"_3w6lk","video":"_3lVb2","icon-wrapper":"_3KYEH"};